import {
  createRouter as createVueRouter,
  createMemoryHistory,
  createWebHistory,
} from 'vue-router';

import { scrollBehavior } from '@ozdao/martyrs/modules/core/client';
import LayoutClient from '@/components/layouts/LayoutClient.vue'

import Logotype from '@/components/icons/Logotype.vue'
import Header from '@/components/partials/Header.vue'
import Footer from '@/components/partials/Footer.vue'

import { Header as MartyrHeader, Sidebar, Navigation } from '@ozdao/martyrs/modules/core/client'

const isServer = typeof window === 'undefined';

let history = isServer ? createMemoryHistory() : createWebHistory();

const routes = [{
  path: '/:locale?',
  name: 'Home',


  components: {
    default: LayoutClient
  },

  meta: {
    location: false,
    header: MartyrHeader,
    header_show_cart: false,
    header_show_profile: false,
    logotype: Logotype,
    sidebar: Sidebar,
    sidebar_navigation: Navigation,
    sidebar_hover: true,
  },

  children: [
    // Главная страница
    {
      path: '',
       name: "Home Page",
      meta: { header: Header, sidebar: false, footer: Footer,
        header_mode: 'overlay',
        title: {
          ru: 'OZ INTERACTIVE – исследование, аналитика, проектирование, дизайн и разработка',
          en: 'OZ INTERACTIVE – research, analytics, design and development'
        },
        description: {
          ru: 'Digital агентство полного цикла из Санкт-Петербурга',
          en: 'Full-cycle digital agency from Saint Petersburg'
        },
        ogImage: '/images/social_avatar.png'
      },
      component: () => import(/* webpackChunkName: 'HomePage' */ '@/components/pages/Home.vue'),
    },

    // О компании
    {
      path: 'about',
      name: 'About',
      meta: { header: Header, sidebar: false, footer: Footer,
        title: {
          ru: 'О компании – OZ INTERACTIVE',
          en: 'About – OZ INTERACTIVE'
        },
        description: {
          ru: 'Команда стратегов, дизайнеров, продюсеров и разработчиков',
          en: 'Team of strategists, designers, producers and developers'
        }
      },
      component: () => import(/* webpackChunkName: 'AboutPage' */ '@/components/pages/About.vue'),
    },

    // Услуги: Forge (новый продукт)
    {
      path: 'services/forge',
      name: 'ServicesForge',
      meta: { header: Header, sidebar: false, footer: Footer,
        title: {
          ru: 'Forge – OZ INTERACTIVE',
          en: 'Forge – OZ INTERACTIVE'
        },
        description: {
          ru: 'Создание нового цифрового продукта с нуля',
          en: 'Building new digital products from scratch'
        }
      },
      component: () => import(/* webpackChunkName: 'ServicesForgePage' */ '@/components/pages/ServicesForge.vue'),
    },

    // Услуги: Extend (расширение команды)
    {
      path: 'services/extend',
      name: 'ServicesExtend',
      meta: { header: Header, sidebar: false, footer: Footer,
        title: {
          ru: 'Extend – OZ INTERACTIVE',
          en: 'Extend – OZ INTERACTIVE'
        },
        description: {
          ru: 'Расширение и усиление вашей команды',
          en: 'Extending and strengthening your team'
        }
      },
      component: () => import(/* webpackChunkName: 'ServicesExtendPage' */ '@/components/pages/ServicesExtend.vue'),
    },

    // Услуги: AI (автоматизация с ИИ)
    {
      path: 'services/ai',
      name: 'ServicesAI',
      meta: { header: Header, sidebar: false, footer: Footer,
        title: {
          ru: 'AI-автоматизация – OZ INTERACTIVE',
          en: 'AI Automation – OZ INTERACTIVE'
        },
        description: {
          ru: 'Автоматизация бизнес-процессов с помощью нейронных сетей',
          en: 'Business process automation with neural networks'
        }
      },
      component: () => import(/* webpackChunkName: 'ServicesAIPage' */ '@/components/pages/ServicesAI.vue'),
    },

    // Услуги
    {
      path: 'services',
      name: 'Services',
      meta: { header: Header, sidebar: false, footer: Footer,
        title: {
          ru: 'Услуги – OZ INTERACTIVE',
          en: 'Services – OZ INTERACTIVE'
        },
        description: {
          ru: 'Стратегия, креатив, разработка и маркетинг',
          en: 'Strategy, creative, development and marketing'
        }
      },
      component: () => import(/* webpackChunkName: 'ServicesPage' */ '@/components/pages/Services.vue'),
    },

    // Портфолио
    {
      path: 'cases',
      name: 'Cases',
      meta: { header: Header, sidebar: false, footer: Footer,
        title: {
          ru: 'Портфолио – OZ INTERACTIVE',
          en: 'Portfolio – OZ INTERACTIVE'
        },
        description: {
          ru: 'Наши проекты для VK, Sberbank, Jaguar и других',
          en: 'Our projects for VK, Sberbank, Jaguar and others'
        }
      },
      component: () => import(/* webpackChunkName: 'CasesPage' */ '@/components/pages/Cases.vue'),
    },

    // Поиск проектов
    {
      path: 'search',
      name: 'Search',
      meta: { header: Header, sidebar: false, footer: Footer,
        title: {
          ru: 'Поиск проектов – OZ INTERACTIVE',
          en: 'Search Projects – OZ INTERACTIVE'
        },
        description: {
          ru: 'Поиск проектов по сектору и навыкам',
          en: 'Search projects by sector and skills'
        }
      },
      component: () => import(/* webpackChunkName: 'SearchPage' */ '@/components/pages/Search.vue'),
    },

    // Рабочая страница для навигации по кейсам
    {
      path: 'cases/working',
      name: 'WorkingCases',
      meta: { header: Header, sidebar: false, footer: Footer,
        title: {
          ru: 'Проекты в работе – OZ INTERACTIVE',
          en: 'Working Cases – OZ INTERACTIVE'
        }
      },
      component: () => import(/* webpackChunkName: 'WorkingCasesPage' */ '@/components/pages/cases/WorkingCasesPage.vue'),
    },

    // Контакты
    {
      path: 'contacts',
      name: 'Contacts',
      meta: { header: Header, sidebar: false, footer: Footer,
        title: {
          ru: 'Контакты – OZ INTERACTIVE',
          en: 'Contacts – OZ INTERACTIVE'
        },
        description: {
          ru: 'Свяжитесь с нами для обсуждения вашего проекта',
          en: 'Contact us to discuss your project'
        }
      },
      component: () => import(/* webpackChunkName: 'ContactsPage' */ '@/components/pages/Contacts.vue'),
    },

    // Case Studies - динамический роут со slug
    {
      path: 'cases/:slug',
      name: 'Case',
      meta: { header: Header, sidebar: false, footer: Footer, header_mode: 'overlay' },
      component: () => import(/* webpackChunkName: 'CasePage' */ '@/components/pages/Case.vue'),
    },

    // 404
    {
      path: ':pathMatch(.*)*',
      name: 'NotFound',
      meta: { header: Header, sidebar: false, footer: Footer },
      component: () => import(/* webpackChunkName: 'NotFound' */ '@/components/pages/NotFound.vue'),
    }
  ]
}];

export function getRouter(context) {
  return createVueRouter({
    routes,
    history,
    scrollBehavior: scrollBehavior('#screen')
  });
}

// Legacy exports for compatibility
export function _createRouter() {
  return getRouter();
}